import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerNavigationSidebarResourceBundleEn(i18next: i18n): void {
  i18next.addResourceBundle('en', 'record-it-components', {
    pageLayout: {
      NavigationSidebar: {
        logout: 'Logout',
        userProfile: 'Profile'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}